// removed by extract-text-webpack-plugin
module.exports = {"radius":"ItemTagIndicator__radius__e63d7a73","wrapper":"ItemTagIndicator__wrapper__e63d7a73","center":"ItemTagIndicator__center__e63d7a73","pulse":"ItemTagIndicator__pulse__e63d7a73","echo":"ItemTagIndicator__echo__e63d7a73"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/gallery/components/ItemTagIndicator.scss
// module id = 1037
// module chunks = 7 23 26 27